module.exports = __webpack_public_path__ + "img/otp.1fd5e7c7.svg";